"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractEmployerEmailDomain = exports.isGenericEmailDomain = void 0;
const email_misspelled_1 = __importStar(require("email-misspelled"));
const GENERIC_EMAIL_DOMAINS = new Set([
    // Global free mail
    "gmail.com",
    "googlemail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "protonmail.com",
    "proton.me",
    "pm.me",
    "duck.com",
    "mail.com",
    "yandex.com",
    "live.com",
    "msn.com",
    "ymail.com",
    "rocketmail.com",
    "myyahoo.com",
    "aim.com",
    "juno.com",
    "netscape.net",
    "mindspring.com",
    "cs.com",
    "qq.com",
    "naver.com",
    "email.com",
    "163.com",
    "mail.ru",
    "yahoo.co.in",
    "yahoo.es",
    "reagan.com",
    "ail.com",
    "usa.net",
    "netzero.net",
    "netzero.com",
    "zoho.com",
    "fastmail.com",
    "gmx.com",
    "gmx.net",
    "gmx.de",
    "web.de",
    "tutanota.com",
    "ukr.net",
    // Regional Yahoo / Hotmail / Outlook / Live variants
    "yahoo.ca",
    "yahoo.co.uk",
    "yahoo.fr",
    "yahoo.com.tw",
    "hotmail.ca",
    "hotmail.fr",
    "hotmail.co.uk",
    "outlook.fr",
    "live.ca",
    "live.fr",
    "live.co.uk",
    // Canadian ISPs
    "videotron.ca",
    "videotron.qc.ca",
    "sympatico.ca",
    "bell.ca",
    "bell.net",
    "rogers.com",
    "rogers.ca",
    "telus.net",
    "shaw.ca",
    "cogeco.ca",
    "eastlink.ca",
    "xplornet.com",
    "cgocable.ca",
    "sasktel.net",
    "globetrotter.net",
    "sogetel.net",
    "telusplanet.net",
    "mymts.net",
    "oricom.ca",
    "nb.aibn.com",
    // French ISPs / free mail
    "orange.fr",
    "free.fr",
    "sfr.fr",
    "wanadoo.fr",
    "laposte.net",
    "numericable.fr",
    "bbox.fr",
    "neuf.fr",
    "aliceadsl.fr",
    // US ISPs
    "comcast.net",
    "comcast.com",
    "verizon.net",
    "att.net",
    "sbcglobal.net",
    "bellsouth.net",
    "charter.net",
    "cox.net",
    "earthlink.net",
    "roadrunner.com",
    "rr.com",
    "optonline.net",
    "optimum.net",
    "frontier.com",
    "frontiernet.net",
    "windstream.net",
    "embarqmail.com",
    "prodigy.net",
    "pacbell.net",
    "twc.com",
    "tds.net",
    "ptd.net",
    "swbell.net",
    "centurylink.net",
    "centurytel.net",
    "cfl.rr.com",
    "tampabay.rr.com",
    "nc.rr.com",
    "nycap.rr.com",
    "carolina.rr.com",
    "snet.net",
    "suddenlink.net",
    "ameritech.net",
    "zoominternet.net",
    "q.com",
    "charter.com",
    "mchsi.com",
    "rcn.com",
    "btinternet.com",
    "atlanticbb.net",
    // Australian ISPs / free mail
    "bigpond.com",
    "bigpond.net.au",
    "optusnet.com.au",
    "iinet.net.au",
    "westnet.com.au",
    "tpg.com.au",
    "dodo.com.au",
    "internode.on.net",
    "yahoo.com.au",
    "hotmail.com.au",
    "live.com.au",
    // New Zealand ISPs / free mail
    "xtra.co.nz",
    "slingshot.co.nz",
    "orcon.net.nz",
    "paradise.net.nz",
    "ihug.co.nz",
    "yahoo.co.nz",
    // Testing / disposable / placeholder mail
    "mailinator.com",
    "mailinator.net",
    "mailinator.co",
    "milinator.com",
    "mailiator.com",
    "maildrop.cc",
    "testmail.com",
    "test.com",
    "mail.co",
    "fakemail.com",
    "noemail.com",
    // RFC-reserved / example domains
    "example.com",
    "example.org",
    // Payment platforms / privacy relays — shared by platform, not by employer.
    "paypalgivingfund.org",
    "onlinegivingfoundation.ca",
    "inbox.appleid.apple.com",
    // Internal Simplyk domain
    "simplyk.io",
    // ISP variants / typos
    "bellnet.ca",
    "sympaticio.ca",
    "gmail.con",
    "gamil.com",
    "gmai.com",
    "gnail.com",
    "gmil.com",
    "gmal.com",
    "hmail.com",
    "yahoo.con",
    "icloud.con",
    "gmail.vom",
    "gmail.co",
    "iclould.com",
    // Real-estate / financial advisor franchises — many independent agents share the domain.
    "kw.com",
    "remax.net",
    "remax-quebec.com",
    "royallepage.ca",
    "compass.com",
    "edwardjones.com",
    "raymondjames.com",
    "ampf.com",
    "nm.com",
    "ft.newyorklife.com",
    "lpl.com",
    "cbrealty.com",
    "exprealty.com",
    "colliers.com",
    "cbre.com",
    "century21.ca",
    "sutton.com",
    "evrealestate.com",
    "thrivent.com",
    "countryfinancial.com",
    "assante.com",
    "sfl.ca",
    "iggpp.ca",
    "ml.com",
    "scotiawealth.com",
    "firstcommand.com",
    "morganstanley.com",
    "fairwaymc.com",
    "guildmortgage.net",
    // Insurance carriers with independent agent networks
    "statefarm.com",
    "allstate.com",
    "farmersagent.com",
    "amfam.com",
    "cooperators.ca",
    "sunlife.com",
    "promutuel.ca",
    "ig.ca",
    "agc.ia.ca",
    "qc.aira.com",
    "hubinternational.com",
    "beneva.ca",
    "uhc.com",
    "goosehead.com",
    "marshmma.com",
    // Franchisees / independent operators under a shared brand
    "notarius.net",
    "dignitymemorial.com",
    "kona-ice.com",
    "pjc.jeancoutu.com",
    "familiprix.ca",
    "marriott.com",
    "sobeys.com",
    "commonspirit.org",
    "mathnasium.com",
    "theupsstore.com",
    "hotworx.net",
    "cruiseplanners.com",
    "nothingbundtcakes.com",
    "expresspros.com",
    "homeinstead.com",
    "mcgill.ca",
    "mail.mcgill.ca",
    "umontreal.ca",
    "utoronto.ca",
    "ualberta.ca",
    "uqo.ca",
    "uqar.ca",
    "uqam.ca",
    "uqtr.ca",
    "ulaval.ca",
    "polymtl.ca",
    "usherbrooke.ca",
    "concordia.ca",
    "carleton.ca",
    "uottawa.ca",
    "ubishops.ca",
    "usask.ca",
    "uregina.ca",
    "umanitoba.ca",
    "ucalgary.ca",
    "mun.ca",
    "dal.ca",
    "mcmaster.ca",
    "queensu.ca",
    "uoguelph.ca",
    "uvic.ca",
    "sfu.ca",
    "ubc.ca",
    "ufv.ca",
    "macewan.ca",
    "uleth.ca",
    "uwinnipeg.ca",
    "uwo.ca",
    "yorku.ca",
    "ecuad.ca",
    "hec.ca",
    // Canadian school boards / municipal / hospital — one domain, varied corp_name per team.
    "hdsb.ca",
    "csdm.qc.ca",
    "cbe.ab.ca",
    "adsb.on.ca",
    "cheo.on.ca",
    "montreal.ca",
    "sherbrooke.ca",
    // US K-12 districts under .org (k12.<state>.us handled by INSTITUTIONAL_DOMAIN_REGEX below).
    "pgcps.org",
    "kckps.org",
    // Misc garbage / not a real company domain
    "facebook.com",
]);
// Academia / government / military suffixes — (^|\.) catches base + subdomains (e.g. mail.harvard.edu).
const INSTITUTIONAL_DOMAIN_REGEX = /(^|\.)(edu|gov|mil|gc\.ca|gouv\.qc\.ca|assnat\.qc\.ca|k12\.[a-z]{2}\.us)$/;
// Module-scoped checker so the npm library's preprocessing only runs once.
const misspellCheck = (0, email_misspelled_1.default)({ domains: email_misspelled_1.all });
const isGenericEmailDomain = (domain) => {
    const lower = domain.toLowerCase();
    return (GENERIC_EMAIL_DOMAINS.has(lower) || INSTITUTIONAL_DOMAIN_REGEX.test(lower) || email_misspelled_1.all.includes(lower));
};
exports.isGenericEmailDomain = isGenericEmailDomain;
// Returns the email's domain only when plausibly an employer domain (not generic, not a typo of one).
const extractEmployerEmailDomain = (email) => {
    if (!email) {
        return null;
    }
    const at = email.lastIndexOf("@");
    if (at < 0 || at === email.length - 1) {
        return null;
    }
    const domain = email.slice(at + 1).toLowerCase();
    if (!domain || domain.includes(" ") || !domain.includes(".")) {
        return null;
    }
    if ((0, exports.isGenericEmailDomain)(domain)) {
        return null;
    }
    // Near-typo check: only treat as generic when the suggested correction is itself in the generic set.
    const suggestions = misspellCheck(email);
    if (suggestions.some((suggestion) => (0, exports.isGenericEmailDomain)(suggestion.suggest))) {
        return null;
    }
    return domain;
};
exports.extractEmployerEmailDomain = extractEmployerEmailDomain;
